import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import formatCurrency from 'src/util/formatCurrency';

export default function AssetSummaryTable({
  priorAssets = { priorQuantity: '', priorValue: '', cost: 0 },
  assetsAdded = { quantityAdded: '', valueAdded: '', cost: 0 },
  assetsRetired = { quantityRetired: '', valueRetired: '', cost: 0 },
  assetsChanged = { qty: '', val: '' },
  total = { count: '', value: '' },
}) {
  const boldStyle = { fontWeight: 700 };
  return (
    <TableContainer component={Paper}>
      <Table aria-label="asset summary table">
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell sx={boldStyle}>Count</TableCell>
            <TableCell sx={boldStyle}>Market Value</TableCell>
            <TableCell sx={boldStyle}>Cost</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Prior Assets</TableCell>
            <TableCell>{priorAssets.priorQuantity}</TableCell>
            <TableCell>{formatCurrency(priorAssets.priorValue)}</TableCell>
            <TableCell>{formatCurrency(priorAssets.cost)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Assets Added</TableCell>
            <TableCell>{assetsAdded.quantityAdded}</TableCell>
            <TableCell>{formatCurrency(assetsAdded.valueAdded)}</TableCell>
            <TableCell>{formatCurrency(assetsAdded.cost)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Assets Deleted</TableCell>
            <TableCell>{assetsRetired.quantityRetired}</TableCell>
            <TableCell>{formatCurrency(assetsRetired.valueRetired)}</TableCell>
            <TableCell>{formatCurrency(assetsRetired.cost)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Assets Changed</TableCell>
            <TableCell>{assetsChanged.qty}</TableCell>
            <TableCell>{formatCurrency(assetsChanged.val)}</TableCell>
            <TableCell>{formatCurrency(assetsChanged.cost)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={boldStyle}>Net Total</TableCell>
            <TableCell sx={boldStyle} data-cy="Net Total Count">
              {total.count}
            </TableCell>
            <TableCell sx={boldStyle} data-cy="Net Total Value">
              {formatCurrency(total.value)}
            </TableCell>
            <TableCell sx={boldStyle} data-cy="Net Total Cost">
              {formatCurrency(total.cost)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
